<template>
    <div>
        <v-dialog v-model="dialog" scrollable width="1000px">
            <v-card flat class="px-2">
                <v-card-title class="justify-center"><h3>{{ title }}</h3></v-card-title>         
                <v-divider/>
                <v-card-text>
                    <v-row no-gutters dense class="ma-2 mb-4">
                        <v-col cols="12" class="red--text" v-if="maildata.taal_code===''">
                            Lead language not set!: Using English
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense class="mt-0">
                        <v-col cols="12">
                            <v-text-field dense label="E-mail from" v-model="maildata.gebr_email" readonly class="mb-1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense>
                        <v-col cols="12">
                            <v-text-field dense label="E-mail to" v-model="maildata.pten_email" class="mb-1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense>
                        <v-col cols="12">
                            <v-text-field dense label="Subject" v-model="mailtext.subject" class="mb-1"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense>
                        <!-- <v-col cols="12">
                            <v-textarea rows="7" dense label="Message" v-model="mailtext.message" class="mb-1"></v-textarea>
                        </v-col> -->
                        <v-col cols="12">
                            <tiptap-vuetify v-model="mailtext.message" :extensions="extensions"/>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12">
                            <select_attachments :attachments="attachments" table="pten" @updateData="updateData"/>
                        </v-col>    
                    </v-row>  
                </v-card-text>  
                <v-divider />
                <v-card-actions>
                    <v-btn class="primary ml-4" small v-on:click="newAttachment()"><v-icon medium class="mr-2">mdi-paperclip</v-icon>Attachment</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="primary ml-4" small v-on:click="sendMail(true)">Preview mail</v-btn>
                    <v-btn :disabled="mailSend" class="primary ml-4" small v-on:click="sendMail(false)"><v-icon medium class="mr-2">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                    <v-btn class="primary ml-4" small v-on:click="closeDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <standard_dialog ref="standard_dialog" /> 
        <pleaseWait ref="pleaseWait" :isPersistent="true" display_text="Sending..." :timerInterval="500" />
        <m_attm ref="m_attm" @updateData="updateData"/>
        <previewPtenEmail ref="previewPtenEmail"/>
    </div>
</template>

<script>
    import 'tiptap-vuetify/dist/main.css';
    import { TiptapVuetify, Heading, Bold, Italic, Underline, Strike,HorizontalRule, Paragraph, BulletList, OrderedList, ListItem, Link, HardBreak, History } from 'tiptap-vuetify';

    import m_attm from "@/components/m_attm.vue";
    import pleaseWait from '@/components/pleaseWait.vue';
    import standard_dialog from '@/components/ui/standard_dialog.vue';
    import select_attachments from '@/components/ui/selectors/select_attachments.vue';
    import previewPtenEmail from '@/components/pten/previewPtenEmail.vue';

    export default {    
        components: {
            pleaseWait,
            standard_dialog,
            select_attachments,
            m_attm,
            previewPtenEmail,
            TiptapVuetify,
        },
        props: {
            pten_encrid: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                dialog: false,
                title: "",
                mailType: "",
                attachments: [],
                selected: [],
                mailtext: {},
                mailSend: false,
                maildata: {},
                buttonCaption: "Send mail",
                buttonIcon: "mdi-email-fast-outline",
                extensions: [
                    History,
                    Bold,
                    Italic,
                    Underline,
                    Strike,
                    [Heading, {
                        options: {
                            levels: [1, 2, 3]
                        }
                    }],
                    ListItem,
                    BulletList,
                    OrderedList,
                    HorizontalRule,
                    Link,
                    Paragraph,
                    HardBreak,
                ],
            }
        },
        watch: {
            dialog(value) {
                if (!value) {
                    this.$emit("actionClick", "closeEmail");
                }
            }
        },
        methods: {
            openDialog(title, mailType) {
                this.dialog = false;
                this.mailSend = false;
                this.title = title;
                this.getPtenEmailData(mailType);
            },
            closeDialog() {
                this.dialog = false;
            },
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
            updateData(data) {
                // console.log(data);
                if (data === "pten") {
                    this.refreshAttachments();
                    return
                }
                
                this[data.field] = data.value;
            },
            newMailText(maildata) {
                return  {
                    subject: maildata.mail_subject,
                    message: maildata.mail_message,
                };
            },    
            getPtenEmailData(mailType) {
                this.MailType = mailType;
                this.$axios.post("ares/json/ares/pten/getPtenEmailData.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenEmailData",
                    },
                    getPtenEmailData: {
                        pten_encrid: this.pten_encrid,
                        mailtype: mailType,
                    },
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: res.data.error.color,
                        });
                    } else {
                        this.maildata = res.data.getPtenEmailData;
                        this.mailtext = this.newMailText(this.maildata);
                        this.dialog = true;
                        this.refreshAttachments();
                    }
                });
            },
            newAttachment() {
                this.$refs.m_attm.open('pten', this.maildata.pten_code, '', 'pten', this.pten_encrid, 0);
            },
            refreshAttachments() {
                this.attachments = [];
                this.$axios.post("ares/json/ares/pten/getPtenAttm.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenAttm",
                    },
                    getPtenAttm: {
                        pten_encrid: this.pten_encrid,
                    },
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: res.data.error.color,
                        });
                    } else {
                        this.attachments = res.data.getPtenAttm;
                    }
                });
            },
            sendMail(preview) {
                if (!preview) {
                    this.$refs.pleaseWait.open();
                }
                this.mailtext.htmlMessage = this.convertTextToHtml(this.mailtext.message);
                this.$axios.post("ares/json/ares/pten/sendPtenEmail.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendPtenEmail",
                    },
                    sendPtenEmail: {
                        pten_encrid: this.pten_encrid,
                        attachments: this.selected,       
                        maildata: this.maildata,
                        mailtext: this.mailtext,
                        mailtype: this.mailType,
                        preview: preview,   
                    },
                }).then(res => {
                    if (res.data.error) {
                        if (!preview) {
                            this.$refs.pleaseWait.close();
                        }
                        this.$refs.standard_dialog.open('error', 'Error', res.data.error.message); 
                    } else {
                        if (!preview) {
                            this.mailSend = true;
                            this.buttonCaption = 'Mail sent';
                            this.buttonIcon = 'mdi-check-circle-outline';
                            this.$refs.pleaseWait.close();
                        } else {
                            this.$refs.previewPtenEmail.openDialog(this.maildata, this.mailtext, this.selected, res.data.mtlc);
                            //window.open(res.data.preview_url, '_blank');  
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .scrollable {
        max-height: 400px;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>